<template>
    <div>
        <i class="fas fa-search pointer text-primary" data-toggle="modal" :data-target="'#modal' + _uid"></i>

        <div :id="'modal' + _uid" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content pb-1">
                    <div class="modal-header mt-3 mb-0">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th v-if="showId">{{ $t('company.id') }}</th>
                                    <th>{{ $t('company.name') }}</th>
                                    <th>{{ $t('company.vatNumber') }}</th>
                                    <th>{{ $t('company.bulstatUic') }}</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr>
                                    <td v-if="showId"></td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.name"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.vatNumber"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.bulstatUic"
                                               @input="onInput">
                                    </td>
                                </tr>
                                <tr v-if="!isEmpty && (!searching && (!resultCompanies || resultCompanies.length) < 1)">
                                    <td colspan="5">{{ $t('searchDropdown.noResults') }}</td>
                                </tr>
                                <tr class="pointer" v-for="company in resultCompanies"
                                    @click="onCompanySelected($event, company)"
                                    :key="company.id">
                                    <td v-if="showId">{{ company.id }}</td>
                                    <td>{{ company.name }}</td>
                                    <td>{{ company.vatNumber }}</td>
                                    <td>{{ company.bulstatUic }}</td>
                                </tr>
                                <div class="justify-content-between">
                                    <div class="pagerInfoMessages pl-1" v-if="companiesFoundCount > 0 && resultCompanies.length < companiesFoundCount">
                                        {{ $t('person.notAllFoundRecordsDiplayed') }}
                                    </div>
                                    <div class="pagerInfo mr-1" v-if="companiesFoundCount > 0">
                                        <span class="font-bold">{{ resultCompanies.length }}</span> {{ $t('of') }} <span class="font-bold">{{ companiesFoundCount }}</span> {{ $t('items') }}
                                    </div>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { CompanySearchModel } from '@/models/models';

    export default {
        components: {},
        props: {
            value: [String, Number],
            expanded: {
                type: Boolean,
                default: false
            },
            showId: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searching: false,
                searchModel: new CompanySearchModel(),
                resultCompanies: [],
                companiesFoundCount: null
            }
        },
        mounted() {
            if (this.expanded) {

            }
        },
        methods: {
            onInput() {
                if (this.searchModel.name.length > 0 || this.searchModel.vatNumber.length > 0 || this.searchModel.bulstatUic.length > 0) {
                    this.search(this);
                } else {
                    this.resultCompanies = [];
                    this.companiesFoundCount = null;
                }
            },
            search: _.debounce(vm => {
                vm.resultCompanies = [];
                vm.searching = true;

                vm.$http.post('/api/search/company', vm.searchModel).then(result => {
                    vm.resultCompanies = [];
                    if (result) {
                        vm.resultCompanies = result.data.companies;
                        vm.companiesFoundCount = result.data.companiesFoundCount;
                    }
                }).catch(error => {

                }).then(() => (vm.searching = false));
            }, 350),
            onCompanySelected(event, selectedCompany) {
                this.$emit('onCompanySelected', selectedCompany);
                this.resultCompanies = [];
                $('#modal' + this._uid).modal('hide');
            }
        },
        computed: {
            isEmpty() {
                return this.searchModel.name.length < 1 && this.searchModel.vatNumber.length < 1 && this.searchModel.bulstatUic.length < 1;
            }
        }
    }
</script>

<style scoped>
    .pagerInfo {
        position: absolute;
        right: 0;
        color: rgba(0,0,0,0.54);
    }

    .pagerInfoMessages {
        color: rgba(0,0,0,0.54);
        position: absolute;
        max-width: 70%;
    }

    .pb-1 {
        padding-bottom: 1rem!important;
    }

    .mr-1 {
        margin-right: 24px!important;
    }

    .pl-1 {
        padding-left: 12px!important;
    }

    .font-bold {
        font-weight: bold;
    }
</style>
